import { render, staticRenderFns } from "./EditPublisElementTitle.vue?vue&type=template&id=45e15baa"
import script from "./EditPublisElementTitle.vue?vue&type=script&lang=js"
export * from "./EditPublisElementTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports